<template>
    <div class="row">
        <!-- MODAL -->
        <b-modal id="addCompanyModal">
            <template #modal-header>
                <span v-show="!isEditing">Add School to Checkout List</span>
                <span v-show="isEditing">Edit School</span>
            </template>
            <b-input-group prepend="Id"><b-input type="text" disabled readonly :value="company.id"></b-input></b-input-group>
            <b-input-group prepend="Name"><b-input type="text" :value="company.name" v-model="customCompanyName"></b-input></b-input-group>
            <template #modal-footer="{close}">
                <b-btn @click="close()" variant="secondary">Close</b-btn>
                <b-btn @click="addSchoolToList()" variant="primary">
                    <span v-show="!isEditing">Add</span>
                    <span v-show="isEditing">Save</span>
                </b-btn>
            </template>
        </b-modal>
        <b-modal id="deleteConfirmationModal">
            <template #modal-header>Delete {{company.name}} From List?</template>
            <template #modal-footer="{close}">
                <b-btn @click="close()" variant="secondary">Close</b-btn>
                <b-btn @click="removeSchool(company.id)" variant="danger">Remove</b-btn>
            </template>
        </b-modal>



        <div class="col-5">
            <div>
                <h3 class="d-inline border-bottom">Charter Orgs</h3>
                <span class="popover-info" v-b-popover.hover.bottom="'The organizations in this list will appear on the checkout page as charter options.'">
                    <font-awesome-icon :icon="['fas', 'info-circle']"></font-awesome-icon>
                </span>
            </div>
            <!-- Selected charter schools -->
            <div v-if="charterSchools.length" class="charter-list">
                <b-table small :items="charterSchools" :fields="config.selectedFields" >
                    <template #cell(company_name)="data">
                        <small v-b-popover.hover.lefttop="data.item.company_id">{{data.item.company_name}}</small>
                    </template>
                    <template #cell(actions)="data">
                        <b-btn-group>
                            <b-btn size="sm" variant="primary" @click="showEditModal({id: data.item.company_id, name: data.item.company_name})" :disabled="isLoading">
                                <font-awesome-icon :icon="['fas','edit']"></font-awesome-icon>
                            </b-btn>
                            <b-btn size="sm" variant="danger" @click="showRemoveModal({id: data.item.company_id, name: data.item.company_name})" :disabled="isLoading">
                                <font-awesome-icon :icon="['fas','trash']"></font-awesome-icon>
                            </b-btn>

                        </b-btn-group>
                    </template>
                </b-table>
<!--                <div v-for="(school, i) in charterSchools" :key="`charter_${i}`">-->

<!--                </div>-->
            </div>
        </div>
        <div class="col-7">
            <h3 class="border-bottom">Search Organizations</h3>
            <!-- Search input -->
            <b-input-group prepend="Search">
                <b-select :options="states" v-model="selectedState"></b-select>
                <b-input type="text" v-model="search" @input="searchInput" placeholder="Name..."></b-input>
            </b-input-group>

            <div class="mt-3">
                <div v-if="searchResultCompanies.length">
                    <b-pagination
                        v-model="config.page"
                        :total-rows="config.totalRows"
                        :per-page="config.perPage"
                        aria-controls="my-table"
                    ></b-pagination>
                    <b-table
                        small
                        id="my-table"
                        :fields="config.fields"
                        :items="searchResultCompanies"
                        :per-page="config.perPage"
                        :current-page="config.page"
                        style="font-size: 14.4px"
                    >
                        <template #cell(name)="data">
                            <span v-b-popover.hover.top="data.item.parents">{{data.item.name}}</span>
                        </template>
                        <template #cell(actions)="data">
                            <b-btn v-if="isInList(data.item.id)" variant="danger" @click="showRemoveModal(data.item)" size="sm">
                                <font-awesome-icon :icon="['fas','trash']"></font-awesome-icon>
                            </b-btn>
                            <b-btn v-else variant="primary" @click="showAddModal(data.item)" size="sm">
                                <font-awesome-icon :icon="['fas','plus']"></font-awesome-icon>
                            </b-btn>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {optionStates} from "@/common/states";

export default {
    name: "CharterSchools",
    computed: {
        chartersById() {
            return this.charterSchools.map((item) => item.company_id);
        },
    },
    data:() => ({
        search: null,
        states: optionStates,
        selectedState: null,
        searchResultCompanies: [],
        charterSchools: [],
        company: {company_id: null, name: null,},
        customCompanyName: "",
        isEditing: false,
        isLoading: false,
        config: {
            page: 1,
            perPage: 8,
            totalRows: null,
            fields: [
                {key: 'id', label: 'Company Id'},
                'name', 'city', 'state','zip', 'actions'
            ],
            selectedFields: [
                {key: 'company_name', label: 'Name'},
                'actions'
            ],
        }
    }),
    methods: {
        address(company) {
            return `${company.address}  (${company.zip})`;
        },
        searchInput: _.debounce(function() {
            if (!this.search || this.search === '' || this.search.length < 4)
                return;
            this.searchSchools();
        }, 800),
        searchSchools() {
            this.$store.dispatch('searchSchools', {search: this.search, state: this.selectedState})
                .then((response) => {
                    if (!response)
                        return;

                    if (response.success == 0)
                        return;

                    this.setResults(response.data);

                    //"20525": {
                    //     "id": "20525",
                    //     "name": "Alpine School District (American Fork)",
                    //     "points": 0,
                    //     "address": "575 N 100 E",
                    //     "city": "American Fork",
                    //     "state": "UT",
                    //     "zip": "84003"
                    // },
                })
                .catch((error) => {
                    console.error('Error searching schools:', error);
                    this.$swal({
                        toast: true,
                        html: `${error}`,
                        type: 'error',
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    });
                });
        },
        setResults(result) {
            let arr = Object.values(result);
            console.log(arr);
            this.searchResultCompanies = arr;
            this.config.totalRows = this.searchResultCompanies.length;
        },
        getCharterSchools() {
            this.$store.dispatch('getCharterSchools').then((result) => {
                this.charterSchools = result.data;
                // this.$nextTick(() => {console.log(this.charterSchools)});
            });
        },
        isInList(id) {
            if (typeof id == 'string')
                id = parseInt(id);

            return this.chartersById.includes(id);
        },
        addSchoolToList() {
            this.isLoading = true;
            this.$store.dispatch('addCharterSchool', {id: this.company.id, name: this.customCompanyName})
                .then(() => {
                    this.$swal({
                        toast: true,
                        html: 'Saved',
                        type: 'success',
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    });
                    this.getCharterSchools();
                    this.company = {company_id: null, name: null};
                })
                .finally(() => this.isLoading = false);
            this.$bvModal.hide('addCompanyModal');
        },
        showAddModal(company) {
            this.isEditing = false;
            this.company = company;
            this.customCompanyName = company.name;
            this.$bvModal.show('addCompanyModal');
        },
        showRemoveModal(company) {
            this.company = company;
            this.$bvModal.show('deleteConfirmationModal');
        },
        showEditModal(company) {
            this.isEditing = true;
            this.company = company;
            this.customCompanyName = company.name;
            this.$bvModal.show('addCompanyModal');
        },
        removeSchool(id) {
            this.$store.dispatch('removeCharterSchool', id)
            .then((result) => {
                this.getCharterSchools();
            });
            this.$bvModal.hide('deleteConfirmationModal');
        }

    },

    created() {
        this.getCharterSchools();
        console.log(this.states);
    }
}
</script>

<style scoped>
.charter-list {
    padding-top: 5px;
    font-size: 18px;
    height: 70vh;
    overflow-y: scroll;
}
.popover-info {
    color: green;
    margin: -10px 5px 5px;
}
</style>